<template>
  <div class="main-contaienr">
    <div class="left">
      <!-- 客流设备列表 -->
      <div class="equipment leftChild">
        <cus-border title="客流设备列表" ref="blya1">
          <div class="equipment-group">
            <div class="equipment-item">
              <equipment-list />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 三日客流 -->
      <div class="three-days leftChild">
        <cus-border title="三日客流" ref="blya2">
          <div class="three-days-group">
            <div class="three-days-item">
              <three-days />
            </div>
          </div>
        </cus-border>
      </div>
    </div>
    <div class="center">
      占位
      <!-- <div class="center-map">
        <drawn-map></drawn-map>
      </div> -->
    </div>
    <div class="right">
      <!-- 今日客流趋势预警 -->
      <div class="early-warning rightChild">
        <cus-border title="今日客流趋势预警" ref="blya3">
          <div class="early-warning-group">
            <div class="early-warning-item">
              <early-warning />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 客流趋势 -->
      <div class="trend rightChild">
        <cus-border title="客流趋势" ref="blya4">
          <div class="trend-group">
            <div class="trend-item">
              <trend />
            </div>
          </div>
        </cus-border>
      </div>
      <!-- 月度客流趋势对比 -->
      <div class="monthly-contrast rightChild">
        <cus-border title="月度客流趋势对比" ref="blya5">
          <div class="monthly-contrast-group">
            <div class="monthly-contrast-item">
              <monthly-contrast />
            </div>
          </div>
        </cus-border>
      </div>
    </div>
  </div>
</template>
<script>
  // 导入 地图
  // import drawnMap from '@/components/drawn-map/drawn-map'
  // 导入 边框组件
  import cusBorder from '@/components/cus-border/cus-border'
  // 导入 客流设备列表
  import equipmentList from './components/equipment-list.vue'
  // 导入 三日客流
  import threeDays from './components/three-days'
  // 导入 今日客流趋势预警
  import earlyWarning from './components/early-warning'
  // 导入 月度客流趋势对比
  import monthlyContrast from './components/monthly-contrast'
  // 导入 客流趋势
  import trend from './components/trend'

  export default {
    components: {
      trend,
      monthlyContrast,
      earlyWarning,
      threeDays,
      cusBorder,
      equipmentList,
      // drawnMap,
    },
    data() {
      return {
        // 整体数据统计
        statisticsList: {
          cake: [
            {
              total: 874,
              number: 500,
              name: '当前Wi-Fi连接数',
              color: ['#092F57', '#298FF7'],
            },
            {
              total: 1649,
              number: 1649,
              name: '今日连接峰值',
              color: ['#42082A', '#F037A5'],
            },
            {
              total: 984432,
              number: 894432,
              name: '历史注册用户',
              color: ['#095931', '#00FF7E'],
            },
          ],
        },
        // 应急事件统计
        certificationList: [
          {
            val: 0.45,
            text: '微信',
            textColor: '#88E5D0',
            waveColor: ['rgba(0, 255, 162, 0.2)', 'rgba(0, 255, 162, 0.6)'],
            shadowColor: 'rgba(0, 255, 162, 0.15)',
            borderColor: 'rgba(0, 255, 162, 0.3)',
            position: 'left',
          },
          {
            val: 0.55,
            text: '免登录',
            textColor: '#8daeff',
            waveColor: ['rgba(141, 174, 255, 0.2)', 'rgba(141, 174, 255, 0.6)'],
            shadowColor: 'rgba(141, 174, 255, 0.15)',
            borderColor: 'rgba(141, 174, 255, 0.3)',
            position: 'right',
          },
        ],
      }
    },
    beforeDestroy() {
      this.$animejs.remove(['.leftChild', '.rightChild'])
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let anime = this.$animejs
        anime({
          targets: '.leftChild',
          translateX: [-600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(200),
        })
        anime({
          targets: '.rightChild',
          translateX: [600, 0],
          scale: [0, 1],
          easing: 'easeInOutSine',
          delay: anime.stagger(200),
        })
        window.onresize = () => {
          // this.$nextTick(() => {})
          this.$refs.blya1.init()
          this.$refs.blya2.init()
          this.$refs.blya3.init()
          this.$refs.blya4.init()
          this.$refs.blya5.init()
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .main-contaienr {
    position: relative;
    display: flex;

    .center-map {
      position: absolute;
      height: 100vh;
      width: 100vw;
      left: -1.0416vw;
      top: 0;
    }

    .left,
    .right {
      width: 23.59375vw;
      position: relative;
      z-index: 3;

      // 客流设备列表
      .equipment {
        height: 55vh;

        .equipment-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .equipment-item {
            width: 100%;
          }
        }
      }

      // 三日客流
      .three-days {
        height: 29vh;
        margin: 1.5vh 0;
        .three-days-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          .three-days-item {
            width: 100%;
          }
        }
      }

      // 今日客流趋势预警
      .early-warning {
        height: 24.456vh;

        .early-warning-group {
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .early-warning-item {
            width: 100%;
          }
        }
      }

      // 月度客流趋势对比
      .monthly-contrast {
        height: 29vh;
        margin: 1.5vh 0;

        .monthly-contrast-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;

          .monthly-contrast-item {
            width: 100%;
          }
        }
      }

      // 客流趋势
      .trend {
        height: 29vh;
        margin: 1.5vh 0;

        .trend-group {
          display: flex;
          justify-content: space-between;
          flex-direction: row;

          .trend-item {
            width: 100%;
          }
        }
      }
    }

    .center {
      flex-grow: 1;
      color: transparent;
    }
  }
</style>
